// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"61":"98bbea2b","76":"26399df7","236":"975ef6cf","470":"784dfd20","780":"1c9853df","954":"3e124653"}[chunkId] + ".css";
};